// ユーザー承認：実測した高さだけをCSS変数へ渡す。追従位置はSCSSで定義する。
export function initPaneSticky(panes, desktop, Observer = ResizeObserver) {
  const heights = new Map();
  function sync() {
    for (const pane of panes) {
      if (!desktop.matches) {
        if (heights.has(pane)) pane.style.removeProperty('--pane-height');
        heights.delete(pane);
        continue;
      }
      const height = pane.getBoundingClientRect().height;
      if (!height || heights.get(pane) === height) continue;
      pane.style.setProperty('--pane-height', `${height}px`);
      heights.set(pane, height);
    }
  }
  const observer = new Observer(sync);
  for (const pane of panes) observer.observe(pane);
  desktop.addEventListener('change', sync);
  sync();
  return () => {
    observer.disconnect();
    desktop.removeEventListener('change', sync);
    for (const pane of heights.keys()) pane.style.removeProperty('--pane-height');
    heights.clear();
  };
}
